export default __webpack_public_path__ + "static/media/bookcover - front.b1cb1d7f.png";